export const STROKE_INTERVALS = [{ minimum: 0, maximum: 7, step: 1 }];

export const MARKERS_INTERVALS = [{ minimum: 0, maximum: 14, step: 1 }];
